module.exports = __webpack_public_path__ + "img/b44a195.png";